import { Form, Radio } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { UserContext } from 'app/context/UserContext/UserContext';
import { useGetHotel } from 'app/hooks/data/hotels/useHotel';
import { useCountries } from 'app/hooks/data/useCountries';

type PaymentMethodSectionProps = {
  isEditMode: boolean;
  hotelId: number;
};

export const PaymentMethodSection = ({
  isEditMode,
  hotelId,
}: PaymentMethodSectionProps) => {
  const { isSuperAdmin } = useContext(UserContext);
  const { data: hotel } = useGetHotel(hotelId);
  const { data: countries } = useCountries();

  // eslint-disable-next-line @typescript-eslint/no-shadow -- inner-scope reuse, not a bug
  const country = countries?.find((country) => country.id === hotel?.countryId);

  const disableAll = !isEditMode || !isSuperAdmin;

  return (
    <FormLineLayout label="Method">
      <Form.Item name="paymentMethod">
        <Radio.Group name="method" disabled={disableAll}>
          <Radio value="payout">Payout (Stripe or Adyen)</Radio>
          <Radio value="vcc" disabled={disableAll || !country?.issuingAllowed}>
            VCC (Virtual Credit Card)
          </Radio>
        </Radio.Group>
      </Form.Item>
    </FormLineLayout>
  );
};
